import { useEffect, useState } from "react";
import { Col, Form, Modal, Row, Stack } from "react-bootstrap";
import GradientButton from "../GradientButton";

export default function SalesAgentsModal({ modal }) {
	const [selectedId, setSelectedId] = useState(modal.currentId ?? "");

	useEffect(() => {
		if (modal.show) {
			setSelectedId(modal.currentId ?? "");
		}
	}, [modal.show, modal.currentId]);

	function handleSelect() {
		modal.onSelect?.(selectedId || null);
	}

	function handleClose() {
		modal.onClose?.();
	}

	return (
		<Modal show={modal.show} dialogClassName="td-admin" size="lg" onHide={handleClose}>
			<Modal.Header className="modal-admin-header">
				<div className="modal-admin-heading">Select Sales Agent</div>
			</Modal.Header>
			<Modal.Body>
				<Stack gap={3}>
					<Form.Group as={Row}>
						<Form.Label column sm={3}>
							Sales Agent
						</Form.Label>
						<Col sm={9}>
							<Form.Select
								className="form-control pe-5"
								value={selectedId}
								onChange={(e) => setSelectedId(e.target.value)}
							>
								<option value="">No sales agent selected</option>
								{modal.salesAgents?.map((agent) => (
									<option key={agent.Id} value={agent.Id}>
										{agent.Code}
										{agent.Name ? ` - ${agent.Name}` : ""}
									</option>
								))}
							</Form.Select>
						</Col>
					</Form.Group>
				</Stack>
			</Modal.Body>
			<Modal.Footer className="d-flex flex-column flex-sm-row gap-2">
				<GradientButton title="Cancel" variant="yellowOrange" onClick={handleClose} className="flex-fill" />
				<GradientButton title="Select" variant="greenYellow" onClick={handleSelect} className="flex-fill" />
			</Modal.Footer>
		</Modal>
	);
}
